import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const FormRating = () => (
  <ComponentDocs
    name="<Form.Rating/>"
    entry="Rating"
    propsEntry="RatingProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiRating}
  >
    <ComponentExample
      name="Rating Selection"
      import={import("examples/Forms/FormRating/RatingExample")}
      rawImport={import("examples/Forms/FormRating/RatingExample?raw")}
    />
  </ComponentDocs>
);

export default FormRating;
